// @flow
import { block } from 'nano-bem';

export const b = block('footer');
